<template>
	<div class="modal_wrap">
		<div class="overlay"></div>
		<div class="modal_card type_message">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'ModalMessage',
	data() {
		return {
			hasClass: true,
		};
	},
	mounted() {
		if (!document.body.classList.contains('overflow_h')) {
			document.body.classList.add('overflow_h');
			this.hasClass = false;
		}
	},
	beforeUnmount() {
		if (!this.hasClass) {
			document.body.classList.remove('overflow_h');
		}
	},
};
</script>
